import React, { FC, useEffect, useState } from 'react';
import { IAutomatedData } from './admin-dictionary';
import { Col, Row, Table } from 'antd';
import Button from '/react4xp/mixins/ui/button/button';
import { getAutomatedDictionary } from './actions';
import dayjs from 'dayjs';
import {AdminDictionary} from "/react4xp/parts/admin-dictionary/admin-dictionary.type";
import {validatePrivileges} from "mixins/helpers";

const AutomatedDictionary: FC<AdminDictionary.Props> = (props: AdminDictionary.Props) => {
    const [data, setData] = useState<IAutomatedData[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        onLoadedData();
    }, []);

    const onLoadedData = () => {
        setIsLoading(true);
        getAutomatedDictionary({
            source: 'IBD',
        })
            .then(({ data }) => {
                setData(data);
            })
            .finally(() => setIsLoading(false));
    };

    const columns = [
        {
            title: '№',
            dataIndex: 'index',
            render: index => <span>{index}</span>,
        },
        {
            title: 'Справочник',
            dataIndex: 'ru',
        },
        {
            title: 'Код',
            dataIndex: 'code',
        },
        {
            title: 'Источник',
            dataIndex: 'source',
        },
        {
            title: 'Дата и время обновления',
            dataIndex: 'modifiedDate',
            render: (item) => dayjs(item).format('DD.MM.YYYY HH:mm:ss'),
        },
        {
            title: '',
            width: 100,
            render: () => (
                <span>
                    {validatePrivileges(props.roles, props.privileges, 'PRIV_DICTIONARY_SYNC') && (
                        <Button
                            className="column-button"
                            style={{ marginRight: 3 }}
                            onClick={() => {
                                onLoadedData();
                            }}
                        >
                            Обновить
                        </Button>
                    )}
                </span>
            ),
        },
    ];

    return (
        <div className="poll-screen">
            <Row
                gutter={{ xs: 24, md: 24 }}
                className="my-3"
                justify="space-between"
            >
                <Col></Col>
                <Col>
                    {validatePrivileges(props.roles, props.privileges, 'PRIV_DICTIONARY_SYNC') && (
                        <Button
                            color="gold"
                            onClick={onLoadedData}
                        >
                            Обновить все
                        </Button>
                    )}
                </Col>
            </Row>

            <Table
                className="my-3"
                dataSource={data}
                columns={columns}
                loading={isLoading}
            />
        </div>
    );
};

export default AutomatedDictionary;
